/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import {ClientId,DivisionId,SenderId,SenderName,PrevilageId} from '../../helper/HelperAuth'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'
import ActionUploadFile from '../../store/action/WAProfile/UploadFile'
import ActionUploadSingle from '../../store/action/WAProfile/UploadSingle'
import ActionFetchAllClient from '../../store/action/Client/FetchAll'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import CheckBoxInputField from "../../infra/components/formInput/CustomCheckBoxInput"
// import ActionFetchTemplate from '../../store/action/TemplateHsm/FetchAll'
import './Form.css'
import chargeSample from '../../upload_template/single.txt';

import ActionFetchTemplate from '../../store/action/TemplateHsm/FetchAll'
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import ProductItems from './ProductItems';
import GetStatusMMLite from "../../store/action/WAProfile/GetStatusMMLite";

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      params: fromJS({}),
      form: fromJS({
        "selected-file": null,
        "upload-completed": false,
        "header-message" : "",
        "header-param" : "",
        "header-param-size" : 0,
        //"loaded": 0,
        "client-id": null,
        "division-id": null,
        "sender-id": '',
        "schedule-date": '',
        "schedule-time": '',
        "file-id": '',
        "file-name": '',
        "template-id": '',
        //"media-id": "",
        //"link": "",
       // "header-filename": "",
        "raw-message": "",
        "sender-word":"",
        "msisdn-uat":"",
        "max-msisdn-uat":5,
        "category": "",
        "is-mmlite": false
      }),
      paramHeaderSize: 0,
      formParams: fromJS({}),
      formParamsHeader: fromJS({}),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId :'',
      disabledHead: false,
      buttonParams: fromJS({}),
      parameterDynamicUrl:fromJS({}),
      paramUrlDynamic: '',
      parameterCatalogs:fromJS({}),
      parameterCoupons:fromJS({}),
      templateType : '',
      buttonType : '',
      hasExpired : '',
      parameterLto:fromJS({
        "expired-date": '',
        "expired-hours": '',
        "coupon-code":'',
      }),
      buttonParamsIndex: null,
      hasCopyCode:'',
      activeIndex: null,
      carouselItems: null,
      parameterCarousel:fromJS({
        "media-id": "",
        "link": "",
      }),
      transformedCarouselsRender: null,
      formParamsCarousel:fromJS({}),
      formParamsButtonCarousel:fromJS({}),
      formParamsMpm:fromJS({}),
      mpmSection:[],
      formParamsSectionMpm:fromJS({}),
      newProductId:'',
      isSenderMMLite: false,
      chooseMMLite: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.renderParams = this.renderParams.bind(this)
    this.renderParamsHeader = this.renderParamsHeader.bind(this)
    this.renderParamsButton = this.renderParamsButton.bind(this)
    this.renderSectionButton = this.renderSectionButton.bind(this)
    this.handleCancelFile = this.handleCancelFile.bind(this);
    this.checkPrivilege = this.checkPrivilege.bind(this);
  }

  componentDidMount() {
    this.checkPrivilege()
    this.props.actionFetchAllClient()
  }

  handleCancelFile(){
    var changeVals = this.state.form;
    var statDis = true;
    var actionIdVar = this.state.actionId;

    if(actionIdVar != 5 ){
      // changeVals = changeVals.set('client-id',null).set('sender-id',null).set('division-id',null).set('sender-word',null).set('raw-message',null)
      changeVals = changeVals.set('client-id',null).set('sender-id',null).set('division-id',null).set('sender-word',null)
      statDis = false;
    }
    changeVals = changeVals.set('raw-message',null)
    changeVals = changeVals.set('file-id','');
    changeVals = changeVals.set('file-name','');
    changeVals = changeVals.set('selected-file',null);
    changeVals = changeVals.set('upload-completed', false);
    changeVals = changeVals.set('max-msisdn-uat', 5);

    this.setState({form: changeVals, disabled:false, disabledHead:statDis})
  }

   async handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);

     var actionIdVar = this.state.actionId;

    if (field === "client-id") {
      this.setState({ isSenderMMLite: false, chooseMMLite: false })
      this.props.actionFetchSender(value);
      this.props.actionFetchAllDivision(value);
      if(actionIdVar != 5 ){
        this.props.actionFetchTemplate(value, 'hsm');
      }
      // this.props.actionFetchSender(value,this.state.form.get('client-id'));
      if(value === '' || value === undefined || value===null){
        formVal = formVal.set(field,value).set('sender-id',null).set('division-id',null)
      }else{
        formVal = formVal.set(field,value)
      }
    }

     if(field === "sender-id"){
       this.setState({ isSenderMMLite: false, chooseMMLite: false })
       if(value === '' || value === undefined || value===null){
         formVal = formVal.set(field,value).set('sender-word',null)
       }else{
         formVal = formVal.set(field,value).set('sender-word',label)
         const statusMMLite = await GetStatusMMLite(formVal.get('sender-id'), formVal.get('client-id'));
         this.setState({ isSenderMMLite: statusMMLite.is_mmlite, chooseMMLite: statusMMLite.choose_mmlite })
       }
       this.props.actionFetchTemplate(formVal.get('client-id'), 'hsm',actionIdVar,value);
     }
    this.setState({ form: formVal })

    if (field === 'template-id') {
      //remove all old value params
      this.setState({ formParams: fromJS({}) })

      var obj = fromJS({})
      this.props.Templates.map((item) => {
        if (item.get('template-id') === value) {
          obj = item;
        }
      });

      if (obj.size > 0) {
        formVal = formVal.set("raw-message", obj.get('raw-message'))
        formVal = formVal.set("header-message", obj.get('header') != undefined ?  obj.get('header') : '')
        formVal = formVal.set(" header-param-size", obj.get('header-param'))

        if (obj.get('category') !== undefined) {
          formVal = formVal.set("category", obj.get('category').toLowerCase())
        } else {
          formVal = formVal.set("category", "")
        }
        
        if(formVal.get('category').toLowerCase() === "marketing" && this.state.isSenderMMLite) {
          formVal = formVal.set("is-mmlite", true)
        } else {
          formVal = formVal.set("is-mmlite", false)
        }

        this.setState({ form: formVal })
        const c = obj.get('param-size') !== undefined ? parseInt(obj.get('param-size')) : 0;
        var xparams = fromJS({});
        var formParams = fromJS({});
        for (var i = 1; i <= c; i++) {
          var id = "";
          if (i < 10) {
            id = `param-0${i}`
          } else {
            id = `param-${i}`
          }
          // const id = `param-${i}`
          const lbl = `parameter ${i}`
          xparams = xparams.set(i, fromJS({ 'id': id, 'label': lbl }))
          formParams = formParams.set(id, '')
        }
        let buttonParams = obj.get('button-param-size') !== undefined ? parseInt(obj.get('button-param-size')) : 0;
        let templateTypes = obj.get('template-type');
        let isExpired = obj.get('has-expiration');
        let buttonParamsIndex = [];
        if (obj.get('button-param-index') !== undefined) {
          obj.get('button-param-index').map((item) => {
            buttonParamsIndex.push(item);
          }); 
        }
        let isCopyCode = obj.get('has-button-copy-code');
        this.setState({ params: xparams, formParams:formParams, buttonParams:buttonParams, templateType:templateTypes, hasExpired:isExpired, 
          buttonParamsIndex:buttonParamsIndex, hasCopyCode:isCopyCode });
        this.setState({paramHeaderSize: obj.get('header-param')})
        let carouselItems = obj.get('carousels');
        this.setState({carouselItems:carouselItems});
        if (templateTypes=="carousel") {
          let paramsdata = [];
          let buttondata = [];
          const transformedCarousels = obj.get('carousels').map((carousel,index) => {
            for (let index = 0; index < carousel.get('param-size'); index++) {
              paramsdata.push("");
            }
            for (let index = 0; index < carousel.get('button-param'); index++) {
              buttondata.push("");
            }
            // console.log(carousel.get('button-param-index'),"button param index");
            
            return {
                title: "card " + (index + 1),
                carouselid: carousel.get('carousel-id'),
                index: carousel.get('index'),
                format: carousel.get('format'),
                paramsize: carousel.get('param-size'),
                rawmessage: carousel.get('raw-message'),
                buttonparam: carousel.get('button-param'),
                hidelink:'hide',
                hidemediaid:'hide',
                checkedmedia:false,
                checkedlink:false,
                params:paramsdata,
                buttons:buttondata,
                buttonparamindex:carousel.get('button-param-index'),
            };
          });
          this.setState({transformedCarouselsRender:transformedCarousels});
        }
      }
    }
   }

  handleChangeParam(field, value) {
    var formVal = this.state.formParams;

    formVal = formVal.set(field, value);
    this.setState({ formParams: formVal })

  }

  handleChangeParamButton(field, value){
    let formVal = this.state.parameterDynamicUrl;
    formVal = formVal.set(field, value);
    this.setState({parameterDynamicUrl: formVal})
  }

  handleChangeParamButtonCatalog(field, value){
    let formVal = this.state.parameterCatalogs;
    formVal = formVal.set(field, value);
    this.setState({parameterCatalogs: formVal})
  }

  handleChangeParamButtonCoupon(field, value){
    let formVal = this.state.parameterCoupons;
    formVal = formVal.set(field, value);
    this.setState({parameterCoupons: formVal})
  }

  handleChangeParamButtonLto(field, value){
    let formVal = this.state.parameterLto;
    formVal = formVal.set(field, value);
    this.setState({parameterLto: formVal})
  }

  handleChangeParamHeader(field, value) {
    var formVal = this.state.formParamsHeader;
    formVal = formVal.set(field, value);
    this.setState({ formParamsHeader: formVal })
    var form = this.state.form;
    form = form.set(field, value);
    this.setState({ form: form })
  }

  handleChangeParamMpm(field, value) {
    let formVal = this.state.formParamsMpm;
    formVal = formVal.set(field, value);
    this.setState({ formParamsMpm: formVal })
  }

  handleChangeLinkCarouse(field, value, index){
    let transformedCarouselsRender = this.state.transformedCarouselsRender;
    let transformedCarousels = "";
    if (field == "link") {
      transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
        if (indexCarousel === index){
          return {
            ...item,
            link:value
          }
        } else {
          return item
        }
      })
      this.setState({transformedCarouselsRender:transformedCarousels});
    } else if (field == "mediaId") {
      transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
        if (indexCarousel === index){
          return {
            ...item,
            mediaId: value
          }
        } else {
          return item
        }
      })
      this.setState({transformedCarouselsRender:transformedCarousels});
    }
  }

  handleChangeParamCarousel(field, value, index){
    let transformedCarouselsRender = this.state.transformedCarouselsRender;
    let transformedCarousels = "";
    let idx = field.replace("param","");
    let paramsdata = [];
    transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
      if (indexCarousel === index){
        for (let idxl = 0; idxl < item.params.length; idxl++) {
          if (idxl===Number(idx)) {
            paramsdata.push(value)
          }else{
            paramsdata.push(item.params[idxl])
          }
        }
        return {
          ...item,
          params:paramsdata
        }
      } else {
        return item
      }
    })
    this.setState({transformedCarouselsRender:transformedCarousels});
  }

  handleChangeButtonCarousel(field, value, index){
    let transformedCarouselsRender = this.state.transformedCarouselsRender;
    let transformedCarousels = "";
    let idx = field.replace("button","");
    let buttonsdata = [];
    transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
      if (indexCarousel === index){
        for (let idxl = 0; idxl < item.buttons.length; idxl++) {
          if (idxl===Number(idx)) {
            buttonsdata.push(value)
          }else{
            buttonsdata.push(item.buttons[idxl])
          }
        }
        return {
          ...item,
          buttons:buttonsdata
        }
      } else {
        return item
      }
    })
    this.setState({transformedCarouselsRender:transformedCarousels});
  }

  toggleAccordion(index) {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? null : index
    }));
  }

  async handleSubmit(dispatch) {
    const form = this.state.form;
    const formParams = this.state.formParams;
    const formParamsHeader = this.state.formParamsHeader;
    const paramHeaderSize = this.state.paramHeaderSize
    const buttonParams = this.state.buttonParams
    const buttonParamsIndex = this.state.buttonParamsIndex
    const parameterDynamicUrl = this.state.parameterDynamicUrl
    const templateType = this.state.templateType;
    const parameterCatalogs = this.state.parameterCatalogs
    const parameterCoupons = this.state.parameterCoupons
    const parameterLto = this.state.parameterLto
    const hasExpired = this.state.hasExpired
    const hasCopyCode = this.state.hasCopyCode
    const transformedCarouselsRender = this.state.transformedCarouselsRender
    const formParamsSectionMpm = this.state.formParamsSectionMpm
    const formParamsMpm = this.state.formParamsMpm
    const isSenderMMLite = this.state.isSenderMMLite
    let paramHeaderMessage = ''

    let isValid = true;
    let dataparam = []
    let msisdnUat = []

    //validasi jumlah uat msisdn number
    let totalMsisdn = form.get('max-msisdn-uat');
    let validTotalMsisdn = true;
    // eslint-disable-next-line array-callback-return

    const convertdata = formParams.toJS();
    

    const transformedData = Object.keys(convertdata)
      .map((key) => ({
        key,
        value: convertdata[key],
        order: parseInt(key.split("-")[1], 10), // Ekstrak angka untuk sorting
      }))
      .sort((a, b) => a.order - b.order); // Urutkan berdasarkan angka

    // Use forEach instead of map, and add return for callback
    transformedData.forEach((v) => {
      if (v.value === "") {
        isValid = false;
      }
      dataparam.push({
        "type": "text",
        "text": v.value
      });
    });
    
    // formParams.map((v, k) => {
    //   if (v === "") {
    //     isValid = false;
    //   }

    //   dataparam.push(
    //     {
    //       "type": "text",
    //       "text": v
    //     })
    // })

    if(form.get('msisdn-uat') != null ){
      // msisdnUat = form.get('msisdn-uat').split(',');
      msisdnUat = form.get('msisdn-uat').replace(/\s/g, "").split(',');
      let inputTotalMsisdn = msisdnUat.length;
      if(inputTotalMsisdn>totalMsisdn){
        validTotalMsisdn=false;
      }
    }

    // console.log(form.get('header-param'))
    form.map((v,k)=>{
      if(k != 'msisdn-uat'){

        if(v==='' && paramHeaderSize > 0){
          isValid=false
        }
      }
    })

    let databutton = []
    let parambutton = []
    let limitedtime = ""
    let cards = []
    let mpmdatas = []
    let parametersMpm = []
    let sectionMpm = []
    if (buttonParams > 0) {
      let keydata = 0;
      parameterDynamicUrl.map((value,key)=>{
        if (value === "") {
          isValid = false;
        }
        parambutton.push({
          "text":value
        })
        if (templateType) {
          keydata = (keydata+1)
        }
        databutton.push(
          {
            "sub-type":"url",
            "index":buttonParamsIndex[key],
            "parameters":parambutton
          }
        )
      })
    }
    // console.log(templateType,"template type");
    // console.log(transformedCarouselsRender,"formParamsSectionMpm")
    if (templateType==="catalog") {
      parameterCatalogs.map((value,key)=>{
        databutton.push({
          "sub-type": "CATALOG",
          "index": key,
          "parameters": [
              {
                  "thumbnail-product-retailer-id": value
              }
          ]
        })
      })
    } else if (templateType==="coupon") {
      parameterCoupons.map((value,key)=>{
        console.log(key,"key coupon")
        if (key==0) {
          databutton.push({
            "sub-type": "COPY_CODE",
            "index": key,
            "parameters": [
                {
                    "coupon-code": value
                }
            ]
          })
        }else{
          databutton.push({
            "sub-type": "url",
            "index": (key+1),
            "parameters": [
                {
                    "text": value
                }
            ]
          })
        }
      })
    } else if (templateType==="lto") {
      let expiredTime = "";
      if (hasExpired == true) {
        if (parameterLto.get('expired-date') === "" 
        || parameterLto.get('expired-date') === undefined
        || parameterLto.get('expired-hours') === "" 
        || parameterLto.get('expired-hours') === undefined) {
          isValid = false;
        }
      } else if (hasCopyCode == true) {
        if (parameterLto.get('coupon-code') === "" 
        || parameterLto.get('coupon-code') === undefined) {
          isValid = false;
        }
      } else if (hasCopyCode == true && hasExpired == true) {
        if (parameterLto.get('expired-date') === "" 
        || parameterLto.get('expired-date') === undefined
        || parameterLto.get('expired-hours') === "" 
        || parameterLto.get('expired-hours') === undefined
        || parameterLto.get('coupon-code') === "" 
        || parameterLto.get('coupon-code') === undefined) {
          isValid = false;
        }
      } else{
        isValid = true;
      }

      parameterLto.map((value,key)=>{
        if (key=="expired-date") {
          expiredTime = value;
        }else if (key==="expired-hours") {
          if (hasExpired == true) {
            expiredTime = expiredTime+" "+value+":00";
          } else {
            expiredTime = "";
          }
          limitedtime=
            {"parameters": [
                {
                  "expiration-time": expiredTime
                }
            ]
          };
        }else if (key === "coupon-code") {
          databutton.push({
            "sub-type": "COPY_CODE",
            "index": 0,
            "parameters": [
                {
                    "offer-code": value
                }
            ]
          })
        }
      })
    } else if (templateType==="carousel") {
      transformedCarouselsRender.map((value,key)=>{
        // console.log(value,"value carousel");
        let parameterBody = []
        let dataButtonCarousel = []
        let parameterButton = []
        let componentsHeader = []
        for (let index = 0; index < value.paramsize; index++) {
          if (value.params[index]) {
            parameterBody.push({
              "type": "text",
              "text": value.params[index]
            }) 
          }     
        }
        for (let index = 0; index < value.buttonparam; index++) {
          if (value.buttons[index]) { 
            parameterButton.push({
              "text":value.buttons[index]
            })
            dataButtonCarousel.push({
              "sub-type": "url",
              "index": value.buttonparamindex,
              "parameters": parameterButton
            }) 
          }
        }
        if (value.hidelink=="") {
          componentsHeader.push({
            "carousel-id": value.carouselid,
            "header": {
              "type":value.format,
              "link":value.link,
            },
            "body":{
              "parameters":parameterBody
            },
            "buttons":dataButtonCarousel
          })
        }else{
          componentsHeader.push({
            "carousel-id": value.carouselid,
            "header": {
              "type":value.format,
              "media-id":value.mediaId,
            },
            "body":{
              "parameters":parameterBody
            },
            "buttons":dataButtonCarousel
          })
        }
        cards.push({
          "card-index":key,
          "components":componentsHeader,
        })
      })
    } else if (templateType === "mpm"){
      formParamsSectionMpm.map((value,key)=>{
        let productItemsMpm = []
        for (let index = 0; index < value.product.productId.length; index++) {
          productItemsMpm.push({
            "product-retailer-id":value.product.productId[index]
          }) 
        }
        sectionMpm.push({
          "title":value.product.titleProduct,
          "product-items":productItemsMpm,
        })
      })
      parametersMpm.push({
        "action":{
          "thumbnail-product-retailer-id": formParamsMpm.get('thumbnail-product'),
          "sections":sectionMpm,
        }
      })
      mpmdatas.push({
        "sub-type": "mpm",
        "index": 0,
        "parameters": parametersMpm
      })
    }

    let templates = {
      "template-id": form.get('template-id'),
      "body": {
        "parameters": dataparam
      },
      "buttons":databutton,
    }
    if (templateType=="lto") {
      templates = {
        "template-id": form.get('template-id'),
        "body": {
          "parameters": dataparam
        },
        "buttons":databutton,
        "limited-time-offer":limitedtime,
      }
    }else if (templateType=="carousel") {
      templates = {
        "template-id": form.get('template-id'),
        "body": {
          "parameters": dataparam
        },
        "buttons":databutton,
        "carousel":{
          "cards": cards
        },
      }
    }else if (templateType=="mpm") {
      templates = {
        "template-id": form.get('template-id'),
        "body": {
          "parameters": dataparam
        },
        "buttons":databutton,
        "mpm-buttons":mpmdatas,
      }
    }
    if (paramHeaderSize > 0) {
      paramHeaderMessage = formParamsHeader.get('header-param')
      if (templateType=="lto") {
        templates = {
          "template-id": form.get('template-id'),
          "header": {
            "parameters": [
              {
                "type": "text",
                "text": paramHeaderMessage
              }
            ]
          },
          "body": {
            "parameters": dataparam
          },
          "buttons":databutton,
          "limited-time-offer":limitedtime,
        }
      } else if (templateType=="carousel") {
        templates = {
          "template-id": form.get('template-id'),
          "header": {
            "parameters": [
              {
                "type": "text",
                "text": paramHeaderMessage
              }
            ]
          },
          "body": {
            "parameters": dataparam
          },
          "buttons":databutton,
          "carousel":{
            "cards": cards
          },
        }
      } else if (templateType=="mpm") {
        templates = {
          "template-id": form.get('template-id'),
          "header": {
            "parameters": [
              {
                "type": "text",
                "text": paramHeaderMessage
              }
            ]
          },
          "body": {
            "parameters": dataparam
          },
          "buttons":databutton,
          "mpm-buttons":mpmdatas,
        }
      }else{
        templates = {
          "template-id": form.get('template-id'),
          "header": {
            "parameters": [
              {
                "type": "text",
                "text": paramHeaderMessage
              }
            ]
          },
          "body": {
            "parameters": dataparam
          },
          "buttons":databutton,
        }
      }
    }
    let data = {
      "uploads": [
        {
          "client-id": form.get('client-id'),
          "division-id": form.get('division-id'),
          "header-param": paramHeaderSize,
          "type": "template",
          "template": templates,
          "sender-id": form.get('sender-id'),
          "schedule-date": form.get('schedule-date'),
          "schedule-time": form.get('schedule-time'),
          "file-id": form.get('file-id'),
          "file-name": form.get('file-name'),
          "number-add": msisdnUat,
          "is-mmlite": isSenderMMLite ? form.get('is-mmlite') : false
        }
      ]
    }

    // console.log(data,'data');
    

    if (isValid === true) {
      if (validTotalMsisdn === true) {
        let response = await this.props.actionUploadSingle(data);
        if (response.ok) {
          let res = fromJS(await response.json());
          if (res.get('errors') !== undefined) {
            res = res.get('errors').get(0)
            toast.success(res.get('details'), toast.POSITION.TOP_RIGHT);
          } else {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          }
          setTimeout(function () {
            window.location = "ListUpload";
          }, 2000);
        }
      } else {
        toast.error('Over limit uat number. Maximum uat number is ' + totalMsisdn, toast.POSITION.TOP_RIGHT);
      }
    } else {
      toast.error('All field must be fill', toast.POSITION.TOP_RIGHT);
    }

  }

  async handleUploadFile() {
    var file = this.state.form.get('selected-file');
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderWord = this.state.form.get('sender-word');
    if(varClientId && varDivisionId && varSenderWord) {
  var response = await this.props.actionUploadFile(file, 'SINGLE', varSenderWord, varClientId, varDivisionId, "1");
      if (response.get('success')) {
        let newForm = this.state.form;

        newForm = newForm.set('file-id', response.get('file-id'));
        newForm = newForm.set('file-name', response.get('file-name'));
        newForm = newForm.set('upload-completed', true);
        if(response.get('max-msisdn-uat')){
          newForm = newForm.set('max-msisdn-uat', response.get('max-msisdn-uat'));
        }
        this.setState({
          form: newForm,
          disabled: true,
          disabledHead: true
        })
      }else {
        // toast.error('Upload Failed', toast.POSITION.TOP_RIGHT);
      }
    }else{
      toast.error('Client, Division, Sender and file must be filled',toast.POSITION.TOP_RIGHT);
    }
  }

  handleCancel() {
    window.location = 'ListUpload'
  }

  handleOnFileChanged() {
    let newForm = this.state.form;
    newForm = newForm.set("selected-file", event.target.files[0]);
    this.setState({
      form: newForm
    })
  }

  checkPrivilege(){
    this.props.actionGetAccessModuleIdAction('Single Text').then((dataAkses) => {
      if (dataAkses) {
        let varActionId=dataAkses.get("action-id");
        if(varActionId==5){
          this.props.actionFetchSender(ClientId);
          this.props.actionFetchAllDivision(ClientId);
          this.props.actionFetchTemplate(ClientId, 'hsm',varActionId,SenderId);
          var formVal = this.state.form;
          formVal = formVal.set('client-id',ClientId).set('sender-id',SenderId).set('division-id',DivisionId).set('sender-word',SenderName);
          //debugger;
          this.setState({
            form: formVal,
            disabledHead: true,
            actionId :varActionId,
          })
          GetStatusMMLite(SenderId, ClientId).then((statusMMLite) => this.setState({ isSenderMMLite: statusMMLite.is_mmlite, chooseMMLite: statusMMLite.choose_mmlite }));
        } else {
          this.setState({
            actionId :varActionId,
          })
        }
      }
    })
  }

  render() {
    const { form, isSenderMMLite, chooseMMLite, errors } = this.state;

    return (

      <div className="clearfix">
        <div className="card-noborder">
          <h4>
            Single Text
          </h4>
        </div>
        <div className="card">
          <div className="body clearfix">
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <a className="btn btn-success" href={chargeSample} download="single.txt">DOWNLOAD FILE UPLOAD</a>
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                      'source': this.props.Clientall,
                      'value': 'client-id',
                      'label': 'client-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Client"
                    // disabled={this.state.disabled}
                    disabled={this.state.disabledHead}
                    hasError={errors.has('client-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='division-id'
                    value={form.get('division-id')}
                    options={fromJS({
                      'source': this.props.Divisionall,
                      'value': 'division-id',
                      'label': 'division-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Division"
                    // disabled={this.state.disabled}
                    disabled={this.state.disabledHead}
                    hasError={errors.has('division-id')}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">Sender</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='sender-id'
                    value={form.get('sender-id')}
                    options={fromJS({
                      'source': this.props.Senders,
                      'value': 'sender-id',
                      'label': 'sender-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Sender"
                    // disabled={this.state.disabled}
                    disabled={this.state.disabledHead}
                    hasError={errors.has('sender-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">File Upload</span>
              <div className="col-sm-10">
                <input className="form-control" type="file" name="file" disabled={this.state.disabled} onChange={this.handleOnFileChanged} />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <button type="button"
                  className="btn btn-info"
                  disabled={this.state.disabled}
                  onClick={this.handleUploadFile}>
                  Upload
                </button>
                <button type="button"
                        className="btn btn-danger"
                        disabled={!this.state.disabled}
                        onClick={this.handleCancelFile}>
                  Change
                </button>
                <label className="lbl-info">
                  {"filename : " + form.get('file-name')}
                </label>
                <label className="lbl-info">
                  {"file-id : " + form.get('file-id')}
                </label>
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Send Date</span>
              <div className="col-sm-10">
                <DatePickerInput
                  convertvalue
                  minDate={new Date()-1}
                  field="schedule-date"
                  dateFormat="yyyy-MM-dd"
                  value={form.get('schedule-date')}
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Send Time</span>
              <div className="col-sm-10">
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="schedule-time"
                  value={form.get('schedule-time')}
                  dateFormat="HH:mm:ss"
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Template</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='template-id'
                  value={form.get('template-id')}
                  options={fromJS({
                    'source': this.props.Templates,
                    'value': 'template-id',
                    'label': 'template-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="template"
                  // disabled={this.state.disabled}
                  hasError={errors.has('template-id')}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <TextInputField className="form-control"
                                textarea
                                disabled="true"
                                field={'header-message'}
                                value={form.get('header-message')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="header message"
                                hasError={errors.has('header-message')}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <TextInputField
                    className="form-control"
                    textarea
                    disabled="true"
                    field={'raw-message'}
                    value={form.get('raw-message')}
                    onChange={(field, value) => this.handleChange(field, value)}
                    placeholder="raw-message"
                    hasError={errors.has('raw-message')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Parameter Header</span>
              <div className="col-sm-10">
                {
                  this.renderParamsHeader()
                }
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Parameter</span>
              <div className="col-sm-10">
                {
                  this.renderParams()
                }
              </div>
            </div>
            {
              this.renderSectionButton()
            }
            <div className="form-group">
              <span className="col-sm-2">UAT Msisdn</span>
              <div className="col-sm-10">
                <TextInputField className="form-control"
                    textarea
                    // disabled="false"
                    field={'msisdn-uat'}
                    value={form.get('msisdn-uat')}
                    onChange={(field, value) => this.handleChange(field, value)}
                    placeholder="Msisdn for UAT. ex: 6281234567, 6281234568"
                    // hasError={errors.has('msisdn-uat')}
                />
              </div>
            </div>
            {(form.get("category") === "marketing" && isSenderMMLite && chooseMMLite) && (
              <div className="form-group">
                <span className="col-sm-2"></span>
                <div className="col-sm-10">
                  <CheckBoxInputField className="form-control"
                      field={"is-mmlite"}
                      checked={form.get('is-mmlite')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      label="MM Lite"
                  />
                </div>
              </div>
            )}
            
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-6">
                <button type="button"
                  className="btn btn-width btn-danger"
                  value="Cancel"
                  onClick={this.handleCancel}>
                  Cancel
              </button>
                <button type="button"
                  disabled={!form.get("upload-completed")}
                  className="btn btn-width btn-success"
                  onClick={this.handleSubmit}>
                  Submit
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  renderParamsHeader() {
    const { formParams, paramHeaderSize, errors } = this.state
    let dis = true
    let valueParam = ""
    if(paramHeaderSize > 0) {
      dis = false
      valueParam = formParams.get("header-param")
    }

    return (
        <div className="form-group">
          {/*<span>{lbl}</span>*/}
          <div>
            <TextInputField
                className="form-control"
                field={"header-param"}
                value={valueParam}
                onChange={(field, value) => this.handleChangeParamHeader(field, value)}
                placeholder={"header-param"}
                hasError={errors.has("header-param")}
                disabled = {dis}
            />
          </div>
        </div>
    )
  }
  renderParams() {
    const { params, formParams, errors } = this.state


    if (params.size === 0) {
      return (<div className="form-group"></div>)
    }

    return params.toList().map((item) => {
      const field = item.get('id')
      const lbl = item.get('label')
      return (
        <div className="form-group">
          {/*<span>{lbl}</span>*/}
          <div>
            <TextInputField className="form-control"
              field={field}
              value={formParams.get(field)}
              onChange={(field, value) => this.handleChangeParam(field, value)}
              placeholder={lbl}
              hasError={errors.has(field)}
            />
          </div>
        </div>
      )
    })
  }

  renderParamsCarousel(params,indexparam) {
    const {errors, transformedCarouselsRender } = this.state
    if (params === 0) {
      return (<div className="form-group"></div>)
    }else{
      let renders = [];
      transformedCarouselsRender.map((item, indexCarousel) => {
        if (indexCarousel === indexparam){
          for (let index = 0; index < item.paramsize; index++) {
            renders.push(
              <div className="form-group">
                <div>
                  <TextInputField className="form-control"
                    field={"param"+index}
                    value={item.params[index]}
                    onChange={(field, value) => this.handleChangeParamCarousel(field, value, indexCarousel)}
                    placeholder={"Param "+(index+1)}
                    hasError={errors.has(index)}
                  />
                </div>
              </div>
            )
          }
        }
      })
      return renders;
    }
  }
  renderParamsButtonCarousel(buttonparam,indexparam){
    const { transformedCarouselsRender, errors } = this.state
    if (buttonparam === 0) {
      return (<div className="form-group"></div>)
    }else{
      let renders = [];
      transformedCarouselsRender.map((item, indexCarousel) => {
        if (indexCarousel === indexparam){
          for (let index = 0; index < buttonparam; index++) {
            renders.push(
              <div className="form-group">
                <div>
                  <TextInputField className="form-control"
                    field={"button"+index}
                    value={item.buttons[index]}
                    onChange={(field, value) => this.handleChangeButtonCarousel(field, value, indexCarousel)}
                    placeholder={"Param Button "+(index+1)}
                    hasError={errors.has(index)}
                  />
                </div>
              </div>
            )      
          }
        }
      })
      return renders;
    }
  }

  toggleAddSectionMpm(){
    const {mpmSection} = this.state
    // console.log(mpmSection.length,'mpm section');
    if (mpmSection.length < 10) {
      const newSection = {
        id: (mpmSection.length+1),
        title: "Section ",
        product:{
          titleProduct:"",
          productId:[]
        }
      }
  
      this.setState({mpmSection:[...mpmSection, newSection]});
    }else{
      toast.error('Section for Mpm template is max', toast.POSITION.TOP_RIGHT);
    }
  }

  toggleAddProductSectionMpm(index){
    const {mpmSection,newProductId} = this.state
    const addNewProduct = mpmSection.map(productsection => {
      if (productsection.id === index) {
        return {
          ...productsection,
          product: {
            ...productsection.product,
            productId: [...productsection.product.productId, newProductId]
          }
        };
      }
      return productsection;
    })
    this.setState({ mpmSection: addNewProduct });
    // console.log(mpmSection,'add product');
  }

  toggleRemoveSectionMpm(id){
    const {mpmSection} = this.state
    const updatedSections = mpmSection.filter(mpmSection => mpmSection.id !== id);
    this.setState({ mpmSection: updatedSections });
  }

  renderSectionMpm(){
    const {mpmSection,activeIndex,formParamsSectionMpm} = this.state
    let mpmSectionParams = '';
    const handleChangeProductMpm = (field, value, index) => {
      let datas = mpmSection
      datas[index] = {
        ...datas[index],
        product: {
          ...datas[index].product,
          [field]: value
        }
      }
      this.setState({ formParamsSectionMpm: datas, mpmSection:datas })
    }
    return (
      <div className="col-sm-12" style={{padding:"0px"}}>
        <span className="col-sm-2">Mpm Sections</span>
        <div className="col-sm-10">
          <div className="panel-group" id="accordion">
            {mpmSection.map((item, index) => (
              <div className="panel panel-default" key={index}>
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a
                      className={activeIndex === index ? '' : 'collapsed'}
                      onClick={() => this.toggleAccordion(index)}
                      data-toggle="collapse"
                      href={`#mpmsections${index}`}
                    >
                      {item.title}
                    </a>
                  </h4>
                </div>
                <div
                  id={`mpmsections${index}`}
                  className={`panel-collapse collapse ${activeIndex === index ? 'in' : ''}`}
                >
                  <div className="panel-body">
                    <div className="col-sm-12">
                      <a 
                        className="btn btn-danger"
                        style={{float:"right"}}
                        onClick={() => this.toggleRemoveSectionMpm(item.id)}
                      >
                        Remove section
                      </a>
                    </div>
                    <div className="form-group">
                      <span className="col-sm-2">Title</span>
                      <div className="col-sm-10">
                        <TextInputField className="form-control-text"
                          field={'titleProduct'}
                          value={item.product.titleProduct}
                          onChange={(field,value) => handleChangeProductMpm(field, value, index)}
                          placeholder={"Title"}
                        />
                      </div>
                    </div>
                    <ProductItems value={item.product.productId} onChange={(values) => handleChangeProductMpm("productId", values, index)}  />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderSectionButton(){
    const { templateType,buttonParams,activeIndex,parameterCarousel,errors,transformedCarouselsRender,formParamsMpm,mpmSection } = this.state
    let template = '';
    let renderbutton = (<div className="form-group"></div>);
    if (templateType === "carousel") {
      // console.log(transformedCarouselsRender,'render carousel');
      let transformedCarousels = '';
      const handleChangeChecker = (field, value, index) => {
        //debugger
        if (field == "link-check") {
          let hidelink = ''
          if (value == true) {
            hidelink = ''
          } else {
            hidelink = 'hide'
          }
          transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
            if (indexCarousel === index){
              return {
                ...item,
                checkedlink: value,
                checkedmedia: false,
                hidelink: hidelink,
                hidemediaid: 'hide',
              }
            } else {
              return item
            }
          })
          this.setState({transformedCarouselsRender:transformedCarousels});
        } else if (field == "media-check") {
          let hidemedia = ''
          if (value == true) {
            hidemedia = ''
          } else {
            hidemedia = 'hide'
          }
          transformedCarousels = transformedCarouselsRender.map((item, indexCarousel) => {
            if (indexCarousel === index){
              return {
                ...item,
                checkedlink: false,
                checkedmedia: value,
                hidemediaid: hidemedia,
                hidelink: 'hide'
              }
            } else {
              return item
            }
          })
          this.setState({transformedCarouselsRender:transformedCarousels});
        }
      }

      return (
        <div className="col-sm-12" style={{padding:"0px"}}>
          <span className="col-sm-2">Carousel Items</span>
          <div className="col-sm-10">
            <div className="panel-group" id="accordion">
              {transformedCarouselsRender.map((item, index) => (
                <div className="panel panel-default" key={index}>
                  <div className="panel-heading">
                    <h4 className="panel-title">
                      <a
                        className={activeIndex === index ? '' : 'collapsed'}
                        data-toggle="collapse"
                      >
                        {item.title}
                      </a>
                    </h4>
                  </div>
                  <div
                    id={`collapse${index}`}
                  >
                    <div className="panel-body">
                      <div className="form-group">
                        <span className={`col-sm-2 `}>Type Upload File</span>
                        <div className={`col-sm-10`}>
                          <div className={`col-sm-6`}>
                            <span className={`col-sm-2 `}>Link</span>
                            <div className={`col-sm-2`}>
                              <CheckBoxInputField className="form-control"
                                field={"link-check"}
                                checked={item.checkedlink}
                                onChange={(field, value) => handleChangeChecker(field, value, index)}
                              />
                            </div>
                            <span className={`col-sm-2`}>Media Id</span>
                            <div className={`col-sm-2`}>
                              <CheckBoxInputField className="form-control"
                                field={"media-check"}
                                checked={item.checkedmedia}
                                onChange={(field, value) => handleChangeChecker(field, value, index)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`form-group ${item.hidelink}`}>
                        <span className="col-sm-2">Media File Url</span>
                        <div className="col-sm-10">

                          <div className="form-group">
                            <div>
                              <TextInputField className="form-control"
                                field={'link'}
                                value={item.link}
                                onChange={(field, value) => this.handleChangeLinkCarouse(field, value, index)}
                                placeholder="http://"
                                hasError={errors.has('link')}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`form-group ${item.hidemediaid}`}>
                        <span className="col-sm-2">Media Id File</span>
                        <div className="col-sm-10">

                          <div className="form-group">
                            <div>
                              <TextInputField className="form-control"
                                field={'mediaId'}
                                value={item.mediaId}
                                onChange={(field, value) => this.handleChangeLinkCarouse(field, value, index)}
                                hasError={errors.has('media-id')}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <span className={`col-sm-2 `}>Body</span>
                        <div className={`col-sm-10`}>
                          <TextInputField
                            className="form-control"
                            textarea
                            disabled="true"
                            field={'raw-message'+index}
                            value={item.rawmessage}
                            onChange={(field, value) => this.handleChangeCarousel(field, value)}
                            placeholder="raw-message"
                            hasError={errors.has('raw-message')}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <span className={`col-sm-2 `}>Parameter</span>
                        <div className={`col-sm-10`}>
                          {
                            this.renderParamsCarousel(item.paramsize,index)
                          }
                        </div>
                      </div>
                      <div className="form-group">
                        <span className={`col-sm-2 `}>Parameter Button</span>
                        <div className={`col-sm-10`}>
                          {
                            this.renderParamsButtonCarousel(item.buttonparam,index)
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    } else if (templateType === "mpm") {
      return (
        <div>
          <div className="form-group">
            <span className="col-sm-2">Parameter MPM</span>
            <div className="col-sm-10">
              <a 
                className="btn btn-success"
                onClick={() => this.toggleAddSectionMpm()}
              >Add Section</a>
            </div>
          </div>
          <div className="form-group">
            <span className="col-sm-2">Thumbnail Product</span>
            <div className="col-sm-10">
              <TextInputField className="form-control-text"
                field={'thumbnail-product'}
                value={formParamsMpm.get('thumbnail-product')}
                onChange={(field,value) => this.handleChangeParamMpm(field, value)}
                placeholder={"Thumbnail Product"}
              />
            </div>
          </div>
          {
            this.renderSectionMpm()
          }
        </div>
      )
    } else {
      if (templateType == "catalog") {
        template = "Parameter Catalog";
        renderbutton = (<div className="form-group"></div>);
      }else if (templateType == "coupon") {
        template = "Parameter Coupon";
        if (buttonParams !== 0) {
          renderbutton = (<div className="form-group">
            <span className="col-sm-2">Parameter Button</span>
            <div className="col-sm-10">
              {
                this.renderParamsButton()
              }
            </div>
          </div>);
        }
      }else if (templateType == "lto") {
        template = "Parameter LTO";
        if (buttonParams != 0) {
          renderbutton = (<div className="form-group">
            <span className="col-sm-2">Parameter Button</span>
            <div className="col-sm-10">
              {
                this.renderParamsButton()
              }
            </div>
          </div>);
        }
      }else {
        template = "Parameter Button";
        renderbutton = (<div className="form-group"></div>);
      }
      return(
        <div>
          <div className="form-group">
            <span className="col-sm-2">{template}</span>
            <div className="col-sm-10">
              {
                this.renderParamTemplate()
              }
            </div>
          </div>
          <div className="col-sm-12" style={{padding: "0px"}}>
            {
              renderbutton
            }
          </div>
        </div>
      );
    }
  }

  renderParamTemplate() {
    const {parameterCatalogs, parameterCoupons, parameterLto, templateType, hasExpired, hasCopyCode } = this.state
    // console.log(templateType,"render button");
    if (templateType == "catalog") {
      return(
        <div key={"button0"}>
          <TextInputField className="form-control-text"
            field={0}
            value={parameterCatalogs.get(0)}
            onChange={(field,value) => this.handleChangeParamButtonCatalog(field, value)}
            placeholder={"Thumbnail Product"}
          />
        </div>)
    }else if (templateType == "coupon") {
      return(
        <div key={"button0"}>
          <TextInputField className="form-control-text"
            field={0}
            value={parameterCoupons.get(0)}
            onChange={(field,value) => this.handleChangeParamButtonCoupon(field, value)}
            placeholder={"Coupon Code"}
          />
        </div>)
    }else if (templateType == "lto") {
      if (hasExpired == true && hasCopyCode == true) {
        return(
          <div>
            <div className="form-group">
              <span className="col-sm-2">Parameter Expired Date</span>
              <div className="col-sm-10">
                <div key={"button0"}>
                  <DatePickerInput
                    convertvalue
                    minDate={new Date()-1}
                    field="expired-date"
                    dateFormat="yyyy-MM-dd"
                    value={parameterLto.get('expired-date')}
                    onChange={(field, date) => this.handleChangeParamButtonLto(field, date)}
                  />
                  <DatePickerInput
                    className="business-hour-time"
                    type="Time"
                    convertvalue
                    field="expired-hours"
                    value={parameterLto.get('expired-hours')}
                    dateFormat="HH:mm:ss"
                    onChange={(field, date) => this.handleChangeParamButtonLto(field, date)}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">Parameter Coupon</span>
              <div className="col-sm-10">
                <div key={"button0"}>
                  <TextInputField className="form-control-text"
                    field="coupon-code"
                    value={parameterCoupons.get('coupon-code')}
                    onChange={(field,value) => this.handleChangeParamButtonLto(field, value)}
                    placeholder={"Coupon Code"}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }else if (hasExpired == true) {
        return(
          <div className="form-group">
            <span className="col-sm-2">Parameter Expired Date</span>
            <div className="col-sm-10">
              <div key={"button0"}>
                <DatePickerInput
                  convertvalue
                  minDate={new Date()-1}
                  field="expired-date"
                  dateFormat="yyyy-MM-dd"
                  value={parameterLto.get('expired-date')}
                  onChange={(field, date) => this.handleChangeParamButtonLto(field, date)}
                />
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="expired-hours"
                  value={parameterLto.get('expired-hours')}
                  dateFormat="HH:mm:ss"
                  onChange={(field, date) => this.handleChangeParamButtonLto(field, date)}
                />
              </div>
            </div>
          </div>
        )
      }else if (hasCopyCode == true) {
        return(
          <div className="form-group">
            <span className="col-sm-2">Parameter Coupon</span>
            <div className="col-sm-10">
              <TextInputField className="form-control-text"
                field="coupon-code"
                value={parameterCoupons.get('coupon-code')}
                onChange={(field,value) => this.handleChangeParamButtonLto(field, value)}
                placeholder={"Coupon Code"}
              />
            </div>
          </div>
        )
      }else {

      }
    }else{
      return (<div className="col-sm-10">
      {
        this.renderParamsButton()
      }
    </div>);
    }
  }
  renderParamsButton() {
    const { buttonParams, parameterDynamicUrl } = this.state;
    if (buttonParams == 0) {
      return (<div className="form-group"></div>);
    } else {
      let fields = [];
      for (let index = 0; index < buttonParams; index++) {
        let lbl = `button ${index + 1}`;
        fields.push(
          <div key={index}>
            <TextInputField
              className="form-control-text"
              field={index}
              value={parameterDynamicUrl.get(index)}
              onChange={(field, value) => this.handleChangeParamButton(field, value)}
              placeholder={lbl}
            />
          </div>
        );
      }
      return fields;
    }
  }

}


export default connect(
  (state) => {
    return {
      Users: state.user.users,
      Clientall: state.user.clientall,
      Divisionall: state.user.divisionall,
      Senders: state.user.senders,
      Templates: state.user.templateall,
    }
  },
  dispatch => bindActionCreators({
    actionUploadFile: ActionUploadFile,
    actionUploadSingle: ActionUploadSingle,
    actionFetchAllClient: ActionFetchAllClient,
    actionFetchAllDivision: ActionFetchAllDivision,
    actionFetchSender: ActionFetchSender,
    actionFetchTemplate: ActionFetchTemplate,
    actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
  }, dispatch),
)(Form);